module.exports = __webpack_public_path__ + "img/profile.431b0df3.jpg";